export default {
  destroy(savedReply) {
    return this.isAdmin() && (savedReply.leaf || !savedReply.hasChildren);
  },
};
